import MessagesList from './messages-list.vue'
export default MessagesList